import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { isUatEnvironment } from '../../helpers/uatMasking';
import { Pagination } from '@mui/material';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Autocomplete, Typography, FormControl, OutlinedInput, TextField, CardActions, Modal, Box, Select, InputLabel, Divider, Backdrop, CircularProgress } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import OperationsHeader from './OperationsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import debounce from 'lodash.debounce';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};
function CustomPagination({ count, page, onChange }: { count: number, page: number, onChange: (event: React.ChangeEvent<unknown>, value: number) => void }) {
    return (
        <Pagination
            count={count}
            page={page}
            onChange={onChange}
            color="primary"
            shape="rounded"
            variant="outlined"
            showFirstButton
            showLastButton
        
        
        
        />
    );
} 

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    showLoader: boolean;
    pageSize: number;
    rowCount: number;
    filter: string;
    filter_type: string;
    agents: any[];
    anchorEl: any;
    showAddAgent: boolean;
    agentName: string;
    agentMobile: string;
    agentEmail: string;
    agentType: string;
    agentCity: any[];
    agentTypes: any;
    agentId: number | null;
    currentPage:number
}

class Agents extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            showLoader: false,
            pageSize: 10,
            rowCount: 0,
            currentPage:0,
            filter: '',
            filter_type: 'all',
            agents: [],
            anchorEl: null,
            showAddAgent: false,
            agentName: '',
            agentMobile: '',
            agentEmail: '',
            agentType: '',
            agentCity: [],
            agentTypes: {
                'paymentcollectionagent': "Payment Collection Agent",
                'wastecollectionagent': "Waste Collection Agent",
                'wastecollectionandpaymentagent': "Waste Collection and Payment Agent",
                'plantoperator': "Plant Operator",
                'admin': "Admin",
                'plantoperatorincoming': "Plant Operator Incoming Only",
                'plantoperatorsorted': "Plant Operator Sorted Only",
                'plantoperatoroutgoing': "Plant Operator Outgoing Only",
            },
            agentId: null
        }
    }
    public componentDidMount(): void {
        this.fetchAgents();
    }

    public fetchAgents(page: number = 0, limit: number = this.state.pageSize) {
        if (this.props.user.selectedHierarchyIds.length) {
            this.setState({ showLoader: true ,currentPage:page});
            let data = { "hierarchies": this.props.user.selectedHierarchyIds, "filter": this.state.filter, "type": ((this.state.filter_type == "all") ? '' : this.state.filter_type), "page": page + 1, "limit": limit }
            axios.post(`allAgents`, data).then((response: any) => {
                this.setState({ showLoader: false });
                let data: any = response.data.data.data;
                let agents: any = [];
                data.map((agent: any) => {
                    let cities = [];
                    for (let i = 0; i < agent.hierarchies.length; i++) {
                        cities.push(agent.hierarchies[i].info.name);
                    }
                    agents.push({
                        "id": agent.id,
                        "agent_name": agent.name,
                        "mobile": agent.phone,
                        "email": agent.email,
                        "type_id": agent.agent_type,
                        "type": (this.state.agentTypes[agent.agent_type]) ? this.state.agentTypes[agent.agent_type] : agent.agent_type,
                        "outstanding_balance": agent.cash_in_hand,
                        "status": agent.is_active ? "Active" : "Inactive",
                        "cities": cities.join(", ")
                    });
                });
                this.setState({ agents: agents, rowCount: response.data.data.total });
            }).catch((error) => {
                this.setState({
                    showLoader: false
                });
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }
    }

    handleSearch = debounce((page: number = 0, limit: number = this.state.pageSize) => {
        this.fetchAgents(page, limit);
    }, 800);

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);
        const renderMaskedCell = (params: GridCellParams) => (
            <Box
                component="span"
                sx={isUatEnvironment ? {
                    filter: 'blur(4px)',
                    opacity: 0.5,
                    userSelect: 'none',
                } : undefined}
            >
                {params.value}
            </Box>
        );

        const handleAddAgent = (() => {
            this.setState({ showLoader: true });
            let cites: any = [];
            this.state.agentCity.map((item: any) => {
                cites.push(item.id);
            })
            let data: any = {
                name: this.state.agentName,
                phone: this.state.agentMobile,
                email: this.state.agentEmail,
                hierarchies: cites
            };
            if(this.state.agentType){
                data.agent_type = this.state.agentType;
            }
            axios.post(`addAgent`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                if (response.data.success) {
                    this.setState({ showAddAgent: false, agentName: "", agentMobile: "", agentEmail: "", agentType: "", agentCity: [], showLoader: false });
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchAgents();
                } else {
                    this.setState({ showAddAgent: false, agentName: "", agentMobile: "", agentEmail: "", agentType: "", agentCity: [], showLoader: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showAddAgent: false, agentName: "", agentMobile: "", agentEmail: "", agentType: "", agentCity: [], showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        });

        const handleCitySelection = (selectedCities: any[]) => {
            this.setState({ agentCity: selectedCities });
        }

        const toggleAgentStatus = (agentId: any, status: string) => {
            this.setState({ showLoader: true });
            let options = { "agent_id": agentId };
            axios.post(`toggleAgentStatus`, options).then((response: any) => {
                this.setState({ showLoader: false, anchorEl: null });
                toast.success(t("Agent") + ((status == 'Active') ? ' Deactivated ' : ' Activated ') + t("Successfully"), {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchAgents();
            }).catch((error) => {
                this.setState({
                    showLoader: false
                });
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleEditAgent = ((data: any) => {
            this.setState({
                showAddAgent: true,
                agentId: data.id,
                agentName: data.agent_name,
                agentMobile: data.mobile,
                agentEmail: data.email,
                agentType: data.type_id,
                agentCity: data.hierarchies
            })
        })

        const handleUpdateAgent = (() => {
            this.setState({ showLoader: true });
            let data = {
                agent_id: this.state.agentId,
                name: this.state.agentName,
                phone: this.state.agentMobile,
                email: this.state.agentEmail,
                agent_type: this.state.agentType
            };
            axios.post(`agentProfileEdit`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                this.setState({ showAddAgent: false, agentId: null, agentName: "", agentMobile: "", agentEmail: "", agentType: "", agentCity: [], showLoader: false });
                toast.success(t("Agent Updated Successfully"), {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchAgents();
            }).catch((error) => {
                this.setState({ showAddAgent: false, agentId: null, agentName: "", agentMobile: "", agentEmail: "", agentType: "", agentCity: [], showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        })

        const columns: any = [
            {
                headerName: "Id",
                field: "id",
                width: 100
            },
            {
                headerName: t("Agent Name"),
                field: "agent_name",
                width: 200,
                renderCell: renderMaskedCell
            },
            {
                headerName: t("Mobile"),
                field: "mobile",
                width: 150,
                renderCell: renderMaskedCell
            },
            {
                headerName: t("Email"),
                field: "email",
                width: 200,
                renderCell: renderMaskedCell
            },
            {
                headerName: t("City"),
                field: "cities",
                width: 200
            },
            {
                headerName: t("Status"),
                field: "status",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <Typography className={(params.row.status == 'Active') ? 'statusTextSuccess' : 'statusTextError'}>{params.row.status}</Typography>
                )
            },
            {
                headerName: t("Actions"),
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => [
                    <GridActionsCellItem
                        // icon={<FileCopyIcon />}    
                        label={t("Edit Agent")}
                        onClick={() => handleEditAgent(params.row)}
                        showInMenu
                    />,
                    <GridActionsCellItem
                        label={((params.row.status == 'Active') ? t("Deactivate") : t("Activate")) + " " + t("Agent")}
                        onClick={() => toggleAgentStatus(params.id, params.row.status)}
                        showInMenu
                    />
                ]
            }
        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <OperationsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card style={{height: 600}}>
                            <CardHeader
                                title={
                                    <Grid container spacing={2}>
                                        <Grid item md={3} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Agents List")}</Typography>
                                        </Grid>
                                        <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <TextField
                                                    id="filter-input"
                                                    label={t("Search")}
                                                    name="filter"
                                                    value={this.state.filter}
                                                    onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.handleSearch())}
                                                    fullWidth={true}
                                                    size="small"
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                }
                                className="text-left"
                                action={
                                    <CardActions>
                                        <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddAgent: true, agentId: null, agentName: '', agentMobile: '', agentEmail: '' })}>
                                            <Add /> {t("Add Agent")}
                                        </Button>
                                    </CardActions>
                                }
                            />

                            <CardContent>
                                <DataGrid
                                    aria-label={t("Agents List")}
                                    columns={columns}
                                    rows={this.state.agents}
                                    rowCount={this.state.rowCount}
                                    pageSize={this.state.pageSize}
                                    onPageChange={(page) => this.fetchAgents(page)}
                                    onPageSizeChange={(newPageSize) => { this.setState({ pageSize: newPageSize }); this.fetchAgents(0, newPageSize); }}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    // autoHeight={true}
                                    style={{ height: 500 }}
                                    pagination
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                        Pagination: () => (
                                            <CustomPagination
                                                count={Math.ceil(this.state.rowCount / this.state.pageSize)}
                                                page={this.state.currentPage+1}
                                                onChange={(event, page) => this.fetchAgents(page-1)}
                                              
                                            />
                                        )
                                    }}
                                    paginationMode="server"
                                    // onRowClick={(params: GridRowParams) => {
                                    //     this.props.history.push('/operations/agents/' + params.id)
                                    // }}
                                    // className="clickableList"
                                    // checkboxSelection
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showAddAgent}
                    onClose={() => this.setState({ showAddAgent: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={((this.state.agentId) ? t("Edit") : t("Add")) + " " + t("Agent") + ((this.state.agentName) ? ' of ' + this.state.agentName : '')}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddAgent: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="agent-name-input"
                                            label={t("Agent Name") + " *"}
                                            value={this.state.agentName}
                                            onChange={(e: any) => this.setState({ agentName: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="agent-mobile-input"
                                            label={t("Mobile Number") + " *"}
                                            value={this.state.agentMobile}
                                            onChange={(e: any) => this.setState({ agentMobile: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="agent-email-input"
                                            label={t("Email") + " *"}
                                            type={'email'}
                                            value={this.state.agentEmail}
                                            onChange={(e: any) => this.setState({ agentEmail: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    {
                                        (!this.state.agentId) &&
                                        <Grid item md={8} xs={12}>
                                            <FormControl fullWidth={true}>
                                                <Autocomplete
                                                    multiple
                                                    id={"cities"}
                                                    options={this.props.user.selectedHierarchies}
                                                    isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                    getOptionLabel={(option: any) => option.name}
                                                    value={this.state.agentCity}
                                                    onChange={(e: any, value: any) => handleCitySelection(value)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label={t("City") + " *"}
                                                            placeholder={t("Select Cities")}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    }
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showAddAgent: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => (this.state.agentId) ? handleUpdateAgent() : handleAddAgent()}>{(this.state.agentId) ? t("Update") : t("Add")} {t("Agent")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
            </div>
        )
    }
}

export default withRouter(withTranslation()(Agents))
